var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.getTextTag,_vm._g(_vm._b({tag:"component",class:_setup.textRecipe(_setup.props, { className: _setup.props.className }),attrs:{"data-component":"CsText","data-variant":_setup.props.variant,"data-color":_setup.props.color}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }